import React from 'react';

import {
  Box,
  Button,
  Code,
  Flex,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';

import { DOCUMENTATION_FONT_FAMILY } from '../utils';

import { ApiMethodBadge } from './ApiMethodBadge';
import { ApiOperation } from './types';
import { apiOperationUrl } from './utils';

/** A service's public endpoints, each linking to its own page. */
export const ApiServicePage = ({
  title,
  operations,
  onOpen,
}: {
  title: string;
  operations: ApiOperation[];
  onOpen: (url: string) => void;
}) => (
  <Box>
    <Text fontSize="14px" color="primary" mb={2}>
      API Reference
    </Text>
    <Heading
      as="h1"
      fontFamily={DOCUMENTATION_FONT_FAMILY}
      fontSize="34px"
      fontWeight={600}
      color="black"
      mb={8}
    >
      {title}
    </Heading>
    <Stack spacing={2}>
      {operations.map(operation => (
        <Button
          key={operation.id}
          variant="unstyled"
          display="block"
          h="auto"
          px={4}
          py={3}
          textAlign="left"
          fontWeight={400}
          border="1px solid"
          borderColor="gray.200"
          borderRadius={8}
          whiteSpace="normal"
          _hover={{ borderColor: 'primary' }}
          onClick={() => onOpen(apiOperationUrl(operation))}
        >
          <Text fontSize="16px" color="black" mb={1}>
            {operation.summary}
          </Text>
          <Flex gap={2} align="center">
            <ApiMethodBadge method={operation.method} size="xs" />
            <Code bg="transparent" fontSize="13px" color="gray.600">
              {operation.path}
            </Code>
          </Flex>
        </Button>
      ))}
    </Stack>
  </Box>
);
